document.addEventListener('DOMContentLoaded', function () {
    const IS_MOBILE = window.innerWidth <= 992;

    let magnetLenis = null;
    let magnetRafId = null;
    let magnetWheelHandler = null;
    let magnetKeyHandler = null;
    let magnetTouchStartHandler = null;
    let magnetTouchMoveHandler = null;
    let magnetTouchEndHandler = null;
    let headerDarkObserver = null;

    function getMonfaroSectionRevealElements(section) {
        const selectors = [
            '.breadcrumbs',
            '.splash__nav',
            '.hero .wrapper h1',
            '.hero .wrapper p',
            '.hero .wrapper h2',
            '.values--content h2',
            '.values--content p',
            '.values--item',
            '.video .top',
            '.video .play',
            '.video .bottom',
            '.innovation--title',
            '.innovation p',
            '.esg--content .plants__ornament',
            '.esg--content h2',
            '.esg--content > div > div',
            '.esg--content > div:not(.plants__ornament)',
            '.esg--img',
            '.cta .row > div',
            '.cta .container > img',
            '.cta .container > p',
            '.cta .container > h2',
            '.empreendimentos-cta',
            '.section-scroll',
        ];

        const elements = Array.from(new Set(
            selectors.flatMap((selector) => Array.from(section.querySelectorAll(selector)))
        ));

        return elements.filter((element) => (
            !elements.some((child) => child !== element && element.contains(child))
        ));
    }

    function setMonfaroSectionInitialState(section) {
        const elements = getMonfaroSectionRevealElements(section);

        section.classList.remove('is-active');
        if (section.hasAttribute('data-animation')) section.classList.remove('animated-element');
        section.querySelectorAll('[data-animation]').forEach((el) => el.classList.remove('animated-element'));

        if (typeof gsap === 'undefined') {
            elements.forEach((el) => {
                el.style.opacity = '1';
                el.style.transform = 'none';
                el.style.visibility = 'visible';
            });
            return;
        }

        gsap.killTweensOf(elements);
        gsap.set(elements, { autoAlpha: 0, y: 38, clearProps: 'x' });
    }

    function animateMonfaroSection(section, immediate = false) {
        const elements = getMonfaroSectionRevealElements(section);

        section.classList.add('is-active');
        if (section.hasAttribute('data-animation')) section.classList.add('animated-element');
        section.querySelectorAll('[data-animation]').forEach((el) => el.classList.add('animated-element'));

        if (typeof gsap === 'undefined' || !elements.length) return;

        gsap.killTweensOf(elements);
        gsap.fromTo(elements,
            { autoAlpha: 0, y: immediate ? 0 : 38 },
            {
                autoAlpha: 1,
                y: 0,
                duration: immediate ? 0 : 0.85,
                ease: 'power3.out',
                stagger: immediate ? 0 : 0.12,
                overwrite: true,
                clearProps: 'transform,visibility',
            }
        );
    }

    function updateMonfaroActiveSection(sections, currentIndex, immediate = false) {
        sections.forEach((section, index) => {
            const isActive = index === currentIndex;

            if (isActive) {
                if (!section.classList.contains('is-active')) {
                    animateMonfaroSection(section, immediate);
                    section.dispatchEvent(new CustomEvent('monfaro:active'));
                }
                return;
            }

            if (section.classList.contains('is-active')) {
                section.dispatchEvent(new CustomEvent('monfaro:inactive'));
            }
            setMonfaroSectionInitialState(section);
        });
    }

    function updateMobileHeaderThemeBySection(section) {
        const header = document.getElementById('header');
        if (!header || window.innerWidth >= 992) return;

        const isDark = !!section && (section.classList.contains('esg') || section.id === 'footer');
        header.classList.toggle('header-dark', isDark);
    }

    function handleMagnetScroll() {
        const isDesktop = window.innerWidth >= 992;
        const containerSelector = isDesktop ? '#desktop' : '#mobile';
        const sections = Array.from(
            document.querySelectorAll(`${containerSelector} > section, footer`)
        );

        if (!sections.length) return;

        if (window.lenis && typeof window.lenis.destroy === 'function' && window.lenis !== magnetLenis) {
            try { window.lenis.destroy(); } catch (e) { /* noop */ }
            window.lenis = null;
        }

        // ─── Limpa instância anterior completamente ───────────────────
        if (magnetLenis) {
            magnetLenis.destroy();
            magnetLenis = null;
        }
        if (magnetRafId) {
            cancelAnimationFrame(magnetRafId);
            magnetRafId = null;
        }

        // Remove todos os listeners antigos antes de adicionar novos
        if (magnetWheelHandler) window.removeEventListener('wheel', magnetWheelHandler, { passive: false, capture: true });
        if (magnetKeyHandler) window.removeEventListener('keydown', magnetKeyHandler, { capture: true });
        if (magnetTouchStartHandler) window.removeEventListener('touchstart', magnetTouchStartHandler);
        if (magnetTouchMoveHandler) window.removeEventListener('touchmove', magnetTouchMoveHandler);
        if (magnetTouchEndHandler) window.removeEventListener('touchend', magnetTouchEndHandler);

        magnetWheelHandler = null;
        magnetKeyHandler = null;
        magnetTouchStartHandler = null;
        magnetTouchMoveHandler = null;
        magnetTouchEndHandler = null;

        // ─── Nova instância Lenis ─────────────────────────────────────
        magnetLenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel: false,   // DESLIGADO — quem controla o wheel é nosso listener
            smoothTouch: false,
            touchMultiplier: isDesktop ? 1 : 0,
            infinite: false,
            autoResize: true,
        });

        function raf(time) {
            if (!magnetLenis) return;
            magnetLenis.raf(time);
            magnetRafId = requestAnimationFrame(raf);
        }
        magnetRafId = requestAnimationFrame(raf);

        let currentIndex = 0;
        let isSnapping = false;
        let scrollLockTimer;
        let lastScrollTime = 0;
        let touchStartY = 0;

        function goToIndex(index) {
            const clamped = Math.max(0, Math.min(index, sections.length - 1));
            if (clamped === currentIndex && isSnapping) return;
            currentIndex = clamped;
            isSnapping = true;
            clearTimeout(scrollLockTimer);
            updateMonfaroActiveSection(sections, currentIndex);
            updateMobileHeaderThemeBySection(sections[currentIndex]);

            magnetLenis.scrollTo(sections[currentIndex], {
                offset: 0,
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                lock: true,
                force: true,
                onComplete: () => {
                    scrollLockTimer = setTimeout(() => { isSnapping = false; }, 150);
                },
            });

            // Fallback caso onComplete não dispare
            scrollLockTimer = setTimeout(() => { isSnapping = false; }, 1500);
        }

        function syncCurrentIndex() {
            if (!magnetLenis) return;
            const scrollY = magnetLenis.scroll;
            let closest = 0, closestDist = Infinity;
            sections.forEach((section, i) => {
                const dist = Math.abs(scrollY - section.offsetTop);
                if (dist < closestDist) { closestDist = dist; closest = i; }
            });
            currentIndex = closest;
        }

        // ─── Wheel (desktop) ─────────────────────────────────────────
        if (isDesktop) {
            let wheelAccumulator = 0;
            let wheelTimer = null;
            const THRESHOLD = 15;
            const COOLDOWN = 1100;

            magnetWheelHandler = (e) => {
                e.preventDefault();
                e.stopPropagation();

                const now = Date.now();
                if (isSnapping || now - lastScrollTime < COOLDOWN) {
                    wheelAccumulator = 0;
                    return;
                }

                if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

                wheelAccumulator += e.deltaY;
                clearTimeout(wheelTimer);
                wheelTimer = setTimeout(() => { wheelAccumulator = 0; }, 150);

                if (Math.abs(wheelAccumulator) >= THRESHOLD) {
                    const direction = wheelAccumulator > 0 ? 1 : -1;
                    wheelAccumulator = 0;

                    if (direction > 0 && currentIndex < sections.length - 1) {
                        lastScrollTime = now;
                        goToIndex(currentIndex + 1);
                    } else if (direction < 0 && currentIndex > 0) {
                        lastScrollTime = now;
                        goToIndex(currentIndex - 1);
                    }
                }
            };

            // capture: true garante que interceptamos antes de qualquer outro handler
            window.addEventListener('wheel', magnetWheelHandler, { passive: false, capture: true });

            // ─── Teclado (desktop) ───────────────────────────────────
            // Setas/PageUp/PageDown/Espaço/Home/End rolam a página nativamente,
            // pulando o goToIndex — a section aparece sem animar. Interceptamos
            // e navegamos pelo mesmo fluxo do wheel.
            magnetKeyHandler = (e) => {
                const target = e.target;
                if (target instanceof Element && target.closest('input, textarea, select, [contenteditable="true"]')) return;

                let targetIndex = null;
                if (e.key === 'ArrowDown' || e.key === 'PageDown' || (e.key === ' ' && !e.shiftKey)) {
                    targetIndex = currentIndex + 1;
                } else if (e.key === 'ArrowUp' || e.key === 'PageUp' || (e.key === ' ' && e.shiftKey)) {
                    targetIndex = currentIndex - 1;
                } else if (e.key === 'Home') {
                    targetIndex = 0;
                } else if (e.key === 'End') {
                    targetIndex = sections.length - 1;
                } else {
                    return;
                }

                // Bloqueia o scroll nativo mesmo durante o cooldown,
                // senão a página rola sem disparar as animações
                e.preventDefault();

                const now = Date.now();
                if (isSnapping || now - lastScrollTime < COOLDOWN) return;
                if (targetIndex === currentIndex || targetIndex < 0 || targetIndex > sections.length - 1) return;

                lastScrollTime = now;
                goToIndex(targetIndex);
            };

            window.addEventListener('keydown', magnetKeyHandler, { capture: true });
        }

        // ─── Touch (mobile) ──────────────────────────────────────────
        const SWIPE_THRESHOLD = 40;

        magnetTouchStartHandler = (e) => {
            syncCurrentIndex();
            touchStartY = e.touches[0].clientY;
        };

        magnetTouchMoveHandler = (e) => { e.preventDefault(); };

        magnetTouchEndHandler = (e) => {
            const now = Date.now();
            if (isSnapping || now - lastScrollTime < 1200) return;

            const deltaY = touchStartY - e.changedTouches[0].clientY;
            if (Math.abs(deltaY) < SWIPE_THRESHOLD) { goToIndex(currentIndex); return; }

            if (deltaY > 0 && currentIndex < sections.length - 1) {
                lastScrollTime = now;
                goToIndex(currentIndex + 1);
            } else if (deltaY < 0 && currentIndex > 0) {
                lastScrollTime = now;
                goToIndex(currentIndex - 1);
            }
        };

        window.addEventListener('touchstart', magnetTouchStartHandler, { passive: false });
        window.addEventListener('touchmove', magnetTouchMoveHandler, { passive: false });
        window.addEventListener('touchend', magnetTouchEndHandler, { passive: false });

        if (history.scrollRestoration) history.scrollRestoration = 'manual';
        window.scrollTo(0, 0);
        currentIndex = 0;
        sections.forEach(setMonfaroSectionInitialState);
        updateMonfaroActiveSection(sections, currentIndex, true);
        updateMobileHeaderThemeBySection(sections[currentIndex]);
    }

    function handleMobileHeaderTheme() {
        const header = document.getElementById('header');

        if (headerDarkObserver) {
            headerDarkObserver.disconnect();
            headerDarkObserver = null;
        }

        if (!header) return;

        header.classList.remove('header-dark');

        if (window.innerWidth >= 992 || !('IntersectionObserver' in window)) return;

        const themeSections = Array.from(document.querySelectorAll('#mobile .esg, #footer'));
        const visibleSections = new Set();

        if (!themeSections.length) return;

        headerDarkObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    visibleSections.add(entry.target);
                } else {
                    visibleSections.delete(entry.target);
                }
            });

            header.classList.toggle('header-dark', visibleSections.size > 0);
        }, {
            threshold: 0.01,
        });

        themeSections.forEach((section) => headerDarkObserver.observe(section));
    }

    handleMagnetScroll();

    window.addEventListener('resize', () => {
        handleMagnetScroll();
    });

    // hideHeader();
    handleVideo();

    // provisório
    // function hideHeader() {
    //     if (IS_MOBILE) {
    //         let header = document.getElementById('header');

    //         header.classList.add('d-none');
    //         header.style.display = 'none';
    //     }
    // }

    function handleVideo() {
        let videoSection = document.querySelectorAll('.video');

        videoSection.forEach(section => {
            let thumb = section.querySelector('.thumb');
            let playBtn = section.querySelector('.play');
            let video = section.querySelector('.video--file');

            if (!playBtn || !video) return;

            const isIframe = video.tagName === 'IFRAME' || video.dataset.renderType === 'iframe';
            const lightboxHref = isIframe
                ? (video.dataset.originalUrl || video.dataset.embedSrc)
                : video.src;

            const lightbox = GLightbox({
                elements: [{
                    href: lightboxHref,
                    type: 'video',
                    width: 900,
                }],
                autoplayVideos: true,
                skin: 'clean',
                touchNavigation: true,
                closeOnOutsideClick: true,
            });

            // play
            playBtn.addEventListener('click', function (e) {
                e.stopPropagation();

                if (isIframe) {
                    lightbox.open();
                    return;
                }

                if (IS_MOBILE) {
                    lightbox.open();
                    return;
                } else {
                    playVideo();
                }
            });

            if (!isIframe) {
                // pause (mp4 only)
                video.addEventListener('click', pauseVideo);

                // reseta caso vídeo acabe
                video.addEventListener('ended', resetVideo);
            }

            function playVideo() {
                playBtn.classList.toggle('paused');

                thumb.classList.contains('d-none') ? '' : thumb.classList.add('d-none');

                video.play();
                video.classList.remove('not-clickable');

                section.classList.add('playing');
            }

            function pauseVideo() {
                if (!section.classList.contains('playing'))
                    return;

                playBtn.classList.toggle('paused');

                video.pause();
                video.classList.add('not-clickable');
            }

            function resetVideo() {
                section.classList.remove('playing');
                thumb.classList.remove('d-none');
                playBtn.classList.remove('paused');

                video.currentTime = 0;
            }
        })
    }

    // swipers
    const swiperCta = new Swiper('.swiper-cta', {
        slidesPerView: 1,
        freeMode: false,
        loop: true,
        grabcursor: false,
        spaceBetween: 0,
        centeredSlides: true,

        breakpoints: {
            992: {
                slidesPerView: "auto",
                spaceBetween: 0,
                freeMode: true,
                grabcursor: true,
                centeredSlides: false,
            }
        }
    })
})
